import React from 'react';
import { environment } from '../../../environments/environment';
import { Trans } from 'react-i18next';
const ToSField: React.FC = () => {
  return (
    <div className='form-field'>
      <label className='checkbox' htmlFor='register-terms-of-use'>
        <input type='checkbox' id='register-terms-of-use' name='register-terms-of-use' required />
        <span>
          <Trans
            i18nKey='shared.tos'
            components={{
              a: <a href={`${environment.kirbyBaseUrl}/terms-of-use/free`} target='_blank' rel='noopener noreferrer' />,
            }}
          />
        </span>
      </label>
    </div>
  );
};

export default ToSField;
